// components/elements/Pagination/Pagination.jsx
import React from 'react';
import './Pagination.css';

const Pagination = ({ 
    currentPage, 
    totalPages, 
    onPageChange, 
    className = '',
    showInfo = true,
    maxVisible = 5,
    disabled = false,
    size = 'md' // 'sm' | 'md' | 'lg'
}) => {
    if (totalPages <= 1) return null;

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages && !disabled) {
            onPageChange(page);
        }
    };

    const goToPrev = () => {
        if (currentPage > 1 && !disabled) {
            onPageChange(currentPage - 1);
        }
    };

    const goToNext = () => {
        if (currentPage < totalPages && !disabled) {
            onPageChange(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        
        if (end - start + 1 < maxVisible) {
            start = Math.max(1, end - maxVisible + 1);
        }
        
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    const pageNumbers = getPageNumbers();
    const sizeClass = size === 'sm' ? 'pagination-sm' : size === 'lg' ? 'pagination-lg' : '';

    const ArrowLeft = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" />
            <path d="M12 19l-7-7 7-7" />
        </svg>
    );

    const ArrowRight = () => (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="M12 5l7 7-7 7" />
        </svg>
    );

    return (
        <div className={`pagination-wrapper ${className} ${sizeClass}`}>
            <div className="pagination">
                <button
                    onClick={goToPrev}
                    disabled={currentPage === 1 || disabled}
                    className="pagination-btn prev"
                    aria-label="Poprzednia strona"
                >
                    <ArrowLeft />
                    <span>Poprzednia</span>
                </button>

                {pageNumbers[0] > 1 && (
                    <>
                        <button
                            onClick={() => goToPage(1)}
                            className="pagination-btn"
                            disabled={disabled}
                        >
                            1
                        </button>
                        {pageNumbers[0] > 2 && (
                            <span className="pagination-dots">…</span>
                        )}
                    </>
                )}

                {pageNumbers.map((page) => (
                    <button
                        key={page}
                        onClick={() => goToPage(page)}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        disabled={disabled}
                    >
                        {page}
                    </button>
                ))}

                {pageNumbers[pageNumbers.length - 1] < totalPages && (
                    <>
                        {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                            <span className="pagination-dots">…</span>
                        )}
                        <button
                            onClick={() => goToPage(totalPages)}
                            className="pagination-btn"
                            disabled={disabled}
                        >
                            {totalPages}
                        </button>
                    </>
                )}

                <button
                    onClick={goToNext}
                    disabled={currentPage === totalPages || disabled}
                    className="pagination-btn next"
                    aria-label="Następna strona"
                >
                    <span>Następna</span>
                    <ArrowRight />
                </button>
            </div>
        </div>
    );
};

export default Pagination;